import { WidgetParameters } from 'interfaces/WidgetParameters';
import { DeepPartial } from 'redux';
import { WebViewAdapter } from 'services/webViewAdapterService';

export const enum ParameterActionType {
    Init = 'PARAMETERS/INIT',
    Update = 'PARAMETERS/UPDATE',
    SetWebviewAdapter = 'PARAMETERS/SET_WEBVIEW_ADAPTER',
    SetCmsUrl = 'PARAMETERS/SET_CMS_URL',
}

export type InitParametersAction = ReturnType<typeof initParameters>;
export const initParameters = (parameters: WidgetParameters) => ({
    type: ParameterActionType.Init,
    payload: parameters,
});

export type UpdateParametersAction = ReturnType<typeof updateParameters>;
export const updateParameters = (parameters: DeepPartial<WidgetParameters>) => {
    return {
        type: ParameterActionType.Update,
        payload: parameters,
    };
};

export type SetWebviewAdapterAction = ReturnType<typeof setWebviewAdapter>;
export const setWebviewAdapter = (webViewAdapter?: WebViewAdapter) => ({
    type: ParameterActionType.SetWebviewAdapter,
    payload: webViewAdapter || null,
});

export type SetCmsUrlAction = ReturnType<typeof setCmsUrl>;
export const setCmsUrl = (cmsUrl?: string) => ({
    type: ParameterActionType.SetCmsUrl,
    payload: cmsUrl?.trim() ?? '',
});
